<template>
  <div class="fe-relative fe-w-full fe-overflow-hidden">
    <!-- Slider Container -->
    <div
      ref="carousel"
      class="fe-flex sm:fe-overflow-x-auto sm:fe-no-scrollbar fe-gap-xs lg:fe-gap-s"
      :class="sliderClass"
    >
      <div
        v-for="(review, index) in visibleReviewImages"
        :key="review?.id"
        class="fe-flex-shrink-0"
        @click="handleClick(review, review.image?.id, index)"
      >
        <LazyImage
          :src="review?.image?.lowResUrl"
          alt="review image"
          :class-name="[imageSizeClass, 'fe-rounded-large']"
        >
          <div
            v-if="
              index === visibleReviewImages?.length - 1 && remainingImagesCount
            "
            :class="[
              imageSizeClass,
              'fe-absolute fe-top-0 fe-flex fe-justify-center fe-items-center fe-text-body-l-bold fe-text-white fe-bg-primary-grey-80',
            ]"
          >
            <div>+ {{ remainingImagesCount }}</div>
          </div>
        </LazyImage>
      </div>
    </div>
  </div>
</template>

<script>
  import LazyImage from "@/components/DesignSystem/LazyImage/LazyImage.vue"
  import { checkIsMobile } from "@/utils/utils"

  export default {
    name: "ImageListSlider",
    components: {
      LazyImage,
    },
    props: {
      reviews: { type: Array, required: true },
      sliderClass: { type: String, default: "", required: false },
    },
    data() {
      return {
        // showLeftArrow: false,
        // showRightArrow: true,
        visibleReviewImages: [],
        remainingImagesCount: 0,
      }
    },
    mounted() {
      // this.updateArrowVisibility()
      this.getVisibleImages()
      window.addEventListener("resize", this.getVisibleImages)
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getVisibleImages)
    },
    computed: {
      imageSizeClass() {
        // Remember we are using width 100px (desktop image) in getVisibleImages method to calculate how many images needs to be shown.
        // If any changes needs to be made here, then make the changes in that method also
        // For mobile, no calculation is being done, so no issue there
        return `fe-w-[90px] fe-h-[90px] lg:fe-w-[100px] lg:fe-h-[100px]`
      },
    },
    methods: {
      getVisibleImages() {
        let numberOfImagesToShow = 0

        if (checkIsMobile()) {
          // In Mobile, we will show max 8 images only
          numberOfImagesToShow = Math.min(8, this.reviews.length)
        } else {
          // In desktop, we should show number of images which can fit inside the div container, no horizontal scrolling
          // carousel visible width / (100 px (this is image width in desktop) + 16px (padding between images))
          const carousel = this.$refs.carousel

          numberOfImagesToShow = Math.floor(carousel.clientWidth / (100 + 12))
        }

        const visibleReviewImages = this.reviews?.slice(0, numberOfImagesToShow)

        const numberOfReviews = this.reviews?.length
        const numberOfVisibleReviews = visibleReviewImages?.length

        const remainingImagesCount = numberOfReviews - numberOfVisibleReviews

        this.visibleReviewImages = visibleReviewImages
        this.remainingImagesCount = remainingImagesCount
      },
      handleClick(review, imageId, reviewIndex) {
        // If the last image is clicked, then we should show Gallery Image Modal (containing all images)
        if (reviewIndex === this.visibleReviewImages?.length - 1) {
          this.$emit("clickmore")
        } else {
          // In this case, just show Gallery Content Modal (containing review and review image)
          this.$emit("click", {
            review: review,
            imageId: imageId,
          })
        }
      },
    },
    // These below methods were being used for showing right and left side arrow.
    // Since it is not requirement anymore, we have no use. But keeping it here in case we need it in future.
    // scrollLeft() {
    //   this.$refs.carousel.scrollBy({
    //     left: -this.$refs.carousel.clientWidth / 3,
    //     behavior: "smooth",
    //   })
    // },
    // scrollRight() {
    //   this.$refs.carousel.scrollBy({
    //     left: this.$refs.carousel.clientWidth / 3,
    //     behavior: "smooth",
    //   })
    // },
    // onScroll() {
    //   this.updateArrowVisibility()
    // },
    // updateArrowVisibility() {
    //   const carousel = this.$refs.carousel
    //   this.showLeftArrow = carousel.scrollLeft > 0
    //   this.showRightArrow =
    //     carousel.scrollWidth > carousel.clientWidth + carousel.scrollLeft
    // },
  }
</script>
